const kBaseUrl =
  process.env.NEXT_PUBLIC_URL ?? "https://chorebuddy.fimidara.com";

export const kClientPaths = {
  index: "/",
  signin: "/signin",
  signinWithRedirect: (redirectTo: string) =>
    `/signin?redirectTo=${redirectTo}`,
  docs: {
    index: "/docs",
    single: (slug: string) => `/docs/${slug}`,
  },
  app: {
    index: "/app",
    profile: "/app/profile",
    myChores: "/app/my-chores",
    myRequests: "/app/my-requests",
    spaces: {
      index: "/app/spaces",
      workspaces: "/app/spaces?tab=workspaces",
      lists: "/app/spaces?tab=lists",
    },
    workspace: {
      index: "/app/spaces?tab=workspaces",
      single: (workspaceId: string) => `/app/workspaces/${workspaceId}`,
      lists: {
        index: (workspaceId: string) => `/app/workspaces/${workspaceId}/lists`,
      },
      members: {
        index: (workspaceId: string) =>
          `/app/workspaces/${workspaceId}/members`,
      },
      settings: {
        index: (workspaceId: string) =>
          `/app/workspaces/${workspaceId}/settings`,
      },
    },
    list: {
      index: "/app/spaces?tab=lists",
      single: (listId: string) => `/app/lists/${listId}`,
      status: {
        index: (listId: string) => `/app/lists/${listId}/statuses`,
        single: (listId: string, statusId: string) =>
          `/app/lists/${listId}/statuses/${statusId}`,
      },
      priority: {
        index: (listId: string) => `/app/lists/${listId}/priorities`,
        single: (listId: string, priorityId: string) =>
          `/app/lists/${listId}/priorities/${priorityId}`,
      },
      tag: {
        index: (listId: string) => `/app/lists/${listId}/tags`,
        single: (listId: string, tagId: string) =>
          `/app/lists/${listId}/tags/${tagId}`,
      },
      chore: {
        index: (listId: string) => `/app/lists/${listId}/chores`,
        single: (listId: string, choreId: string) =>
          `/app/lists/${listId}/chores/${choreId}`,
      },
      participant: {
        index: (listId: string) => `/app/lists/${listId}/members`,
        single: (listId: string, participantId: string) =>
          `/app/lists/${listId}/members/${participantId}`,
      },
      settings: {
        index: (listId: string) => `/app/lists/${listId}/settings`,
      },
    },
  },
  emailTemplates: {
    index: "/email-templates",
    addParticipant: "/email-templates/add-participant",
  },
  withURL(path: string) {
    return `${kBaseUrl}${path}`;
  },
};
